import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import Seo from "../components/SEO"

import c01 from '../images/c01.jpg'
import c02 from '../images/c02.jpg'
import c03 from '../images/c03.jpg'
import c05 from '../images/c05.jpg'
import c06 from '../images/c06.jpg'
import c07 from '../images/c07.jpg'
import c08 from '../images/c08.jpg'
import c09 from '../images/c09.jpg'
import c11 from '../images/c11.jpg'
import c12 from '../images/c12.jpg'

import pic02 from '../images/coach.jpg'

//import logo from '../images/logo.png'

const CoachPage = ({
    data: {
        site
    },
}) => {
    return (
        <Layout>
            <Seo title="コーチ紹介" image={`${pic02}`} />
            
            <section id="banner" className="style7" style={{backgroundImage: `url(${pic02})`}}>
                <div className="inner">
                    <header className="major">
                        <h2>Coach</h2>
                        <p>コーチ紹介</p>
                    </header>
                </div>
            </section>

            <div id="main">
                <div className="inner">
                    <div className="grid-wrapper">
                        <div className="col-4">

                            <table className="small">
                                <thead></thead>
                                <tbody>
                                    <tr>
                                        <td></td>
                                        <td>
                                            <img src={c01} alt="代表" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>氏名</td>
                                        <td>
                                            篠原 和之<br/>
                                            <span style={{'font-size': '0.8em'}}>SHINOHARA KAZUYUKI</span><br/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>役職</td>
                                        <td>エスブランコ代表</td>
                                    </tr>
                                    <tr>
                                        <td>選手歴</td>
                                        <td>印西町立原山中学校<br/>千葉県立津田沼高等学校<br/>習志野選抜（高校）</td>
                                    </tr>
                                    <tr>
                                        <td>指導歴</td>
                                        <td>1995 クレストSC<br/>1999 FCエスブランコ</td>
                                    </tr>
                                    <tr>
                                        <td>資格</td>
                                        <td>D級ライセンス</td>
                                    </tr>                                        
                                </tbody>
                            </table>
                        </div>

                        <hr/>
                        
                        <div className="col-4">
                            <table className="small">
                                <thead></thead>
                                <tbody>
                                    <tr>
                                        <td></td>
                                        <td>
                                            <img src={c07} alt="ヘッドコーチ" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>氏名</td>
                                        <td>
                                            松田 教正<br/>
                                            <span style={{'font-size': '0.8em'}}>MATSUDA NORIMASA</span><br/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>役職</td>
                                        <td>ヘッドコーチ</td>
                                    </tr>
                                    <tr>
                                        <td>選手歴</td>
                                        <td>京都サンガJrユース<br/>洛南高等学校<br/>大阪産業大学(主将)<br/>京都選抜(小学生〜中学生)<br/>関西学生選抜候補(大学生)<br/>関西学生サッカーリーグ<br/>2部ベストイレブン</td>
                                    </tr>
                                    <tr>
                                        <td>指導歴</td>
                                        <td>2015〜現在 エスブランコ</td>
                                    </tr>
                                    <tr>
                                        <td>資格</td>
                                        <td>D級ライセンス</td>
                                    </tr>                                        
                                </tbody>
                            </table>
                        </div>

                        <hr/>

                        <div className="col-4">
                            <table className="small">
                                <thead></thead>
                                <tbody>
                                    <tr>
                                        <td></td>
                                        <td>
                                            <img src={c05} alt="コーチ" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>氏名</td>
                                        <td>
                                            神尾 航平<br/>
                                            <span style={{'font-size': '0.8em'}}>KAMIO KOUHEI</span><br/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>選手歴</td>
                                        <td>
                                            小岩第一中学校<br/>都立東高等学校
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>指導歴</td>
                                        <td>2012〜現在 エスブランコ</td>
                                    </tr>
                                    <tr>
                                        <td>資格</td>
                                        <td>C級ライセンス<br/>C級ライセンス(GK)</td>
                                    </tr>                                        
                                </tbody>
                            </table>
                        </div>
                        <hr/>
                    </div>
                </div>
            </div>
        </Layout>
)
}

export default CoachPage
export const CoachPageQuery = graphql`
  query CoachPageQuery{
    site {
      siteMetadata {
        title
        description
      }
    }
  }
`
